import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Errors.css"

function ServerErr({ onFocus, value, onChange }) {
    const navigate = useNavigate();
    const reloadPageHandler = () => {
        navigate(-1)
        window.location.reload()
    }
    const [isShowLogoutModal, setIsShowLogOutModal] = useState(false);
    const closeModalsWithClickOnDocument = (e) => {
        if (e.target.className.includes("style-for-close-on-outside")) {
            document.removeEventListener("click", setIsShowLogOutModal(false));
        }
    };
    const handleYes = () => {
        localStorage.clear();
        setIsShowLogOutModal(false);
        setOpenSuccess(true);
        setIsExitVisible(false)
        setTimeout(() => {
            navigate("/");
        }, 2000);
    };
  const [isExitVisible, setIsExitVisible] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
    return (
        <>
            <div className="flex items-center justify-start w-full h-screen flex-col">
                <img src="/500.gif" alt="" />
                <p className="font-bold text-2xl text-red-500 text-center">
                    لطفا بعدا تلاش کنید
                </p>
                <div className="w-full h-[2px] bg-red-200 mt-2"></div>
                <div>
                    <button onClick={() => reloadPageHandler()} className="border-main border-2 rounded-xl px-4 py-1 mt-2 text-center text-main">
                        بازگشت
                    </button>
                    <div className="flex cursor-pointer" onClick={() => setIsShowLogOutModal(true)}>
                        <img src="/desktop/icons/logout.svg" alt="" />
                        <p className="hover:text-red-600">خروج</p>
                    </div>
                </div>
            </div>

            {
                isExitVisible &&
                <div className="flex cursor-pointer" onClick={() => setIsShowLogOutModal(true)}>
                    <img src="/desktop/icons/logout.svg" alt="" />
                    <p>خروج</p>
                </div>
            }


            <div
                onClick={(e) => closeModalsWithClickOnDocument(e)}
                className={`right-0 sm:hidden md:hidden style-for-close-on-outside ${isShowLogoutModal ? "top-0" : "top-[100000px] "
                    } fixed duration-700 w-full h-screen bg-[#8d8d8da1] transition-all flex justify-center items-center z-50`}
            >
                {/* <div className='flex justify-center items-center rounded-lg bg-white w-[50%] flex-col text-center pb-12 pl-4 pr-4 pt-2 shadow-[0px_-1px_10px_1px_#000000] bg-white'> */}
                <div
                    className={`z-50 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 border-5 rounded-xl p-4 bg-red-400 text-white flex flex-col items-center justify-center gap-4 w-80 shadow-sm`}
                >
                    <p className="text-xl font-bold">آیا از خروج اطمینان دارید؟</p>
                    <div className="flex justify-around items-center w-full">
                        <button
                            onClick={handleYes}
                            className="mx-3 w-1/2 text-white-900 px-6 py-2 rounded-xl bg-red-500 z-50"
                        >
                            بله
                        </button>
                        <button
                            onClick={() => setIsShowLogOutModal(false)}
                            className="mx-3 w-1/2 text-red-800 px-6 py-2 rounded-xl bg-orange-500 z-50 "
                        >
                            خیر
                        </button>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </>
    );
}

export default ServerErr